import { observer } from 'mobx-react-lite'
import { type FC, useEffect } from 'react'
import Layout from 'shared/layout/Layout/ui/Layout'
import { initCanny } from 'entities/Canny'
import { eventHeartbeat } from 'entities/DataLog/events/EventHeartbeatLog'
import { initIntercom } from 'entities/Intercom'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { Sidebar } from 'widgets/Sidebar'
import { getAppData } from 'app/shared/lib'
import { SidebarLayout } from './SidebarLayout'

type IAuthLayoutVueProps = {
  type?: 'default' | 'sidebar'
}

export const AuthLayoutVue: FC<IAuthLayoutVueProps> = observer(({ type }) => {
  const entities = useEntitiesContext()
  const { mergeFieldStore, authStore } = entities

  useEffect(() => {
    if (!authStore.isRefresh) return
    if (!authStore.isLoggedIn) return

    getAppData(entities).finally(() => {
      entities.complianceStore.initComplianceUKModal()
    })
    initCanny(entities)
    initIntercom({
      fromAuthorizedApp: true,
      entities: entities,
    })
    entities.numbersStore.initStartNumberModal()
    entities.numbersStore.initConnectTwilioModal()
    entities.remindersStore.init()
    mergeFieldStore.loadAllFields()
    authStore.resetLoggedIn()

    eventHeartbeat(entities)
  }, [authStore.isLoggedIn, authStore.isRefresh])

  if (!authStore.isLoggedIn) return null

  if (type === 'sidebar') {
    return <Sidebar />
  }

  if (type === 'default') {
    return <Layout />
  }

  return <SidebarLayout />
})
